import React from 'react'
import Loading from 'core/subapps/Loading'
import ClassicView from './ClassicView'
import ModernView from './ModernView'

export default function LayoutSwitcher(props) {
  const { isBootstrapped, prefersClassicView } = props

  if (!isBootstrapped) return <Loading />

  if (prefersClassicView) {
    return <ClassicView {...props} />
  }

  return <ModernView {...props} />
}
